import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const BUSINESSES_DOCUMENT_TYPES_REQUEST = 'BUSINESSES_DOCUMENT_TYPES_REQUEST'
export const BUSINESSES_DOCUMENT_TYPES_SUCCESS = 'BUSINESSES_DOCUMENT_TYPES_SUCCESS'
export const BUSINESSES_DOCUMENT_TYPES_FAILURE = 'BUSINESSES_DOCUMENT_TYPES_FAILURE'

export function fetchBusinessDocumentTypes() {
  return {
    [CALL_API]: {
      endpoint: '/api/business/document-types/',
      types: [BUSINESSES_DOCUMENT_TYPES_REQUEST, BUSINESSES_DOCUMENT_TYPES_SUCCESS, BUSINESSES_DOCUMENT_TYPES_FAILURE],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}
